import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { apiPost } from '../utils/backendApi';

// /sso?slug=<instance>&next=<path> — the landing for "Sign in with nventr.io"
// on a hosted instance's login page. Wrapped in RequireAuth, so by the time
// this renders the person has signed in here with their nventr.io password;
// the plane mints the instance's single-use ticket (POST /apps/sso-by-slug,
// same org-role rule as the Apps page button) and sends the browser on. The
// instance's /api/auth/sso verifies it and signs them in. One password, every
// instance they have access to.
export default function InstanceSso() {
  const { search } = useLocation();
  const params = new URLSearchParams(search);
  const slug = (params.get('slug') || '').trim().toLowerCase();
  const next = params.get('next') || '/';
  const [error, setError] = useState('');
  const [instanceUrl, setInstanceUrl] = useState('');

  useEffect(() => {
    if (!slug) { setError('No instance named in the link.'); return; }
    let live = true;
    apiPost('/apps/sso-by-slug', { slug, next })
      .then(({ url }) => { if (live) window.location.replace(url); })
      .catch((e) => {
        if (!live) return;
        setError(e.message || 'sign-in refused');
        try { setInstanceUrl(new URL(`https://${slug}.apps.nventr.io/login`).href); } catch { /* keep empty */ }
      });
    return () => { live = false; };
  }, [slug, next]);

  return (
    <div className="cs-auth-wrap">
      <div className="cs-modal" style={{ maxWidth: 440 }}>
        <h2 style={{ marginTop: 0 }}>{error ? 'Could not sign you in' : `Signing you in to ${slug || 'the instance'}…`}</h2>
        {!error && <p className="cs-help">Checking your access and handing you to the instance. This takes a second.</p>}
        {error && (
          <>
            <div className="cs-empty" style={{ padding: 12, marginBottom: 14, color: 'var(--accent)' }}>{error}</div>
            <p className="cs-help">
              Access to a hosted instance comes from the organization that owns it: org admins, the app's creator, and members granted Dev Console
              access can sign in with their nventr.io account. Ask an admin of that organization to add you, or sign in with an instance account.
            </p>
            {instanceUrl && <a className="cs-btn cs-btn-outline cs-btn-sm" href={instanceUrl}>Back to the instance's sign-in</a>}
          </>
        )}
      </div>
    </div>
  );
}
